import { Maybe } from '@App/common/types'
import dspData from '@App/configs/static/dsps.json'
import { tableCellSanitizer } from '@App/helpers/table-cell-sanitizer'

export const getFormattedDspName = (dspName: Maybe<string>): string =>
    tableCellSanitizer(dspData.find((dsp) => dsp.name === dspName)?.dspName)
